import { render, staticRenderFns } from "./SchoolHistoryTableFormAdd.vue?vue&type=template&id=01bed2a2"
import script from "./SchoolHistoryTableFormAdd.vue?vue&type=script&lang=js"
export * from "./SchoolHistoryTableFormAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports